// src/utils.ts
var STYLE_KEYS = [
  "color",
  "fontSize",
  "fontWeight",
  "lineHeight"
];
function omitStyleProps(props) {
  const clone = { ...props };
  delete clone["type"];
  delete clone["__css"];
  for (const key of STYLE_KEYS) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}
function omitHTMLProps(props) {
  const clone = { ...props };
  delete clone["__css"];
  for (const key in props) {
    if (!STYLE_KEYS.includes(key)) {
      delete clone[key];
    }
  }
  return clone;
}

export {
  omitStyleProps,
  omitHTMLProps
};
